export const tenantErrorCodes = {
  DEVICES_ATTACHED_TO_TENANT_ERROR: 'DEVICES_ATTACHED_TO_TENANT_ERROR',
  MISSING_TENANT_ADMIN: 'MISSING_TENANT_ADMIN',
  COULD_NOT_GET_DEVICE_DATA: 'COULD_NOT_GET_DEVICE_DATA',
};
